import { useState } from "react";
import { useController, useFormContext } from "react-hook-form";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Button from "../../../Buttons/Button";
import Select from "../../../Form/Select";
import Typography from "@mui/material/Typography";
import {
  ALL_PRODUCTS,
  BUTTON_ADD_PRODUCTS,
  PRODUCT_CONFIGURATION_PLACEHOLDER,
  // PRODUCT_LIST,
  PRODUCT_LIST_PLACEHOLDER,
  PRODUCT_SET,
  PRODUCT_SET_PLACEHOLDER,
} from "../../../../i18n/keysTranslations";
import { useTranslationApp } from "../../../../lib/i18next";
import SelectProductsSetTikTok from "./SelectProductsSetTikTok";
import ModalProductListTikTok from "./ModalProductListTikTok";
import { TIKTOK_PRODUCTS_CONFIGURATION_TYPE } from "../../../../utils/constants";
import { getReactHookFormNestedError } from "../../../../utils/errors";

const PRODUCT_TYPE_OPTIONS = [
  {
    value: TIKTOK_PRODUCTS_CONFIGURATION_TYPE.ALL_PRODUCTS,
    label: ALL_PRODUCTS,
  },
  { value: TIKTOK_PRODUCTS_CONFIGURATION_TYPE.PRODUCT_SET, label: PRODUCT_SET },
  // {
  //   value: TIKTOK_PRODUCTS_CONFIGURATION_TYPE.PRODUCT_LIST,
  //   label: PRODUCT_LIST,
  // },
];

const AdProductConfigurationTikTokForm = ({
  name = "productsConfiguration",
  integrationID,
  adAccountID,
  catalogID,
  control,
  errors = {},
  disabled = false,
  onChangeAction = () => {},
}) => {
  const { setValue } = useFormContext();
  const { t } = useTranslationApp();

  const {
    field: { value: config },
  } = useController({
    name,
    control,
    defaultValue: {
      type: TIKTOK_PRODUCTS_CONFIGURATION_TYPE.ALL_PRODUCTS,
      productSetID: "",
      products: [],
    },
  });

  const [modalOpen, setModalOpen] = useState(false);

  const productsError = getReactHookFormNestedError(errors, `${name}.products`);

  const onTypeChange = async (value) => {
    setValue(name, {
      type: value,
      productSetID: "",
      products: [],
    });
    onChangeAction();
  };

  const onToggleModal = () => {
    setModalOpen(!modalOpen);
  };

  const onSaveProducts = (selectedProducts) => {
    setValue(name, { ...config, products: selectedProducts });
    setModalOpen(false);
    onChangeAction();
  };

  return (
    <Grid container spacing={2} sx={{ width: "100%" }}>
      <Grid item xs={12} md={6}>
        <Typography variant="body1" sx={{ mb: 1 }}>
          {t(PRODUCT_CONFIGURATION_PLACEHOLDER)}
        </Typography>
        <Select
          label=""
          variant="filled"
          fullWidth
          name={`${name}.type`}
          control={control}
          errors={errors}
          options={PRODUCT_TYPE_OPTIONS}
          value={config?.type}
          disabled={disabled}
          actionsChange={onTypeChange}
          doTranslate={true}
        />
      </Grid>
      {config?.type === TIKTOK_PRODUCTS_CONFIGURATION_TYPE.PRODUCT_SET && (
        <Grid item xs={12} md={6}>
          <Typography variant="body1" sx={{ mb: 1 }}>
            {t(PRODUCT_SET_PLACEHOLDER)}
          </Typography>
          <SelectProductsSetTikTok
            label=""
            variant="filled"
            name={`${name}.productSetID`}
            fullWidth
            integrationID={integrationID}
            adAccountID={adAccountID}
            catalogID={catalogID}
            disabled={disabled}
            doTranslate={false}
            control={control}
            errors={errors}
            onChangeAction={onChangeAction}
          />
        </Grid>
      )}
      {config?.type === TIKTOK_PRODUCTS_CONFIGURATION_TYPE.PRODUCT_LIST && (
        <Grid item xs={12} md={6}>
          <Typography variant="body1" sx={{ mb: 1 }}>
            {t(PRODUCT_LIST_PLACEHOLDER)}
          </Typography>
          <Box>
            {config?.products && config.products.length > 0 && (
              <Typography variant="body2">
                {config.products.map((p) => p?.name).join(", ")}
              </Typography>
            )}
          </Box>
          <Button
            variant="contained"
            color="secondary"
            onClick={onToggleModal}
            disabled={disabled}
            sx={{
              mt: 1,
            }}
          >
            {t(BUTTON_ADD_PRODUCTS)}
          </Button>
          {productsError?.message && (
            <Typography variant="body2" color="error">
              {productsError?.message}
            </Typography>
          )}
        </Grid>
      )}
      {modalOpen && (
        <ModalProductListTikTok
          modalOpen={modalOpen}
          onCloseModal={onToggleModal}
          integrationID={integrationID}
          adAccountID={adAccountID}
          catalogID={catalogID}
          selectedProducts={
            config?.products?.length > 0
              ? config.products.map((p) => p?.id)
              : []
          }
          onCallbackSelect={onSaveProducts}
        />
      )}
    </Grid>
  );
};

export default AdProductConfigurationTikTokForm;
